/* „Podobne ćwiczenia" — KANON `Cwiczenia` 17.09.2026, `2-karta.html#e`'s `simRow()`.
 *
 * Four cards under the hero, headed by a GREY sparkle pill and the hint that says where the list
 * came from. The strip is `flex: none` over a fixed reserve: the hero above it is `flex: 1` against
 * the same column, so a strip that grew when its read landed would shrink the picture. Its skeleton
 * stands inside that reserve rather than replacing it.
 *
 * Every text leaf states its line-height; every figure is tabular. */

.strip {
  display: flex;
  flex: none;
  flex-direction: column;
  height: var(--h-ex-theatre-similar);
  margin-top: var(--space-5);
}

.head {
  display: flex;
  flex: none;
  gap: var(--space-3);
  align-items: center;

  /* 8, not the 10 the other block heads use: measured off `kanon-02-teatr-light.png`, where the
   * sparkle pill's bottom is y 737 and the first still's top is 748. */
  margin-bottom: var(--space-2);
}

/* The sparkle's pill. `--bg-chip` on `--border` with `--text-2` ink — NEVER an accent wash. Owner
 * decision D6: the accent marks a real action or a real state, and „the app worked this out for
 * you" is neither. */
.sparkle {
  display: inline-grid;
  flex: none;
  place-items: center;
  width: 22px;
  height: 22px;
  color: var(--text-2);
  background: var(--bg-chip);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-7px);
}

.sparkleGlyph {
  display: block;
  width: 13px;
  height: 13px;
}

.title {
  margin: var(--space-0);
  font-size: var(--fs-body);
  font-weight: var(--fw-bold);
  line-height: var(--lh-display);
  letter-spacing: var(--ls-heading);
  color: var(--text);
}

.hint {
  font-size: var(--fs-micro);
  font-weight: var(--fw-medium);
  line-height: var(--lh-display);
  color: var(--text-3);
}

/* Four equal tracks. `minmax(0, 1fr)` and not `1fr`: a grid track's default minimum is its content,
 * so a long movement name would push the fourth card off the column's right edge. */
.cards {
  display: grid;
  flex: 1;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--space-3);
  min-height: 0;
}

.card {
  display: block;
  padding: var(--space-0);
  font: inherit;
  text-align: left;
  cursor: pointer;
  background: none;
  border: none;
}

.card:focus-visible {
  outline: var(--border-focus) solid var(--text);
  outline-offset: var(--space-2px);
}

/* GEOMETRY only — the frame's treatment is `exerciseStill.module.css`'s. 16:11, as the specimen
 * draws it in this variant, rather than the 16:10 the other cards use. */
.still {
  width: 100%;
  aspect-ratio: 16 / 11;
  border-radius: var(--radius-8px);
}

/* ONE line and clipped, so a long name cannot make the fourth card taller than the first — which,
 * in a grid row, would be the whole strip growing and the hero shrinking. */
.name {
  display: block;
  margin: var(--space-7px) var(--space-0) var(--space-3px);
  overflow: hidden;
  font-size: var(--fs-note);
  font-weight: var(--fw-bold);
  line-height: var(--lh-display);
  color: var(--text);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card:hover .name {
  text-decoration: underline;
}

.typeMark {
  display: inline-flex;
  gap: var(--space-6px);
  align-items: center;
  font-size: var(--fs-eyebrow);
  font-weight: var(--fw-extrabold);
  line-height: var(--lh-auto);
  letter-spacing: var(--ls-block);
  text-transform: uppercase;
  white-space: nowrap;
  color: var(--type-ink);
}

.typeGlyph {
  display: block;
  flex: none;
  width: 13px;
  height: 13px;
  color: var(--type-ink);
}

/* The two absences. One line, inside the same reserve, so nothing moves between the three states. */
.absence {
  margin: var(--space-0);
  font-size: var(--fs-micro);
  font-weight: var(--fw-medium);
  line-height: var(--lh-normal);
  color: var(--text-3);
}

/* ── The wait ───────────────────────────────────────────────────────────────────────────────── */

.skelStill {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 11;
}

.skelName {
  display: block;
  width: 72%;
  height: 11px;
  margin-top: var(--space-7px);
}
